import { InputFactoryProp, ORDER_BY } from "../../../../shared/interfaces";
import { SearchOutlined } from "@ant-design/icons";
import { COLORS } from "../../../../config/themes/colors";
import { VendorType, VendorTypeDescription } from "../../../../shared/interfaces/enums/vendor-values-enum";

const VENDOR_TYPES_IN_FILTER = [
  VendorType.RUEDAS_Y_CRISTALES,
  VendorType.CRISTALES,
  VendorType.RUEDAS,
  VendorType.TODOS,
];

export const vendorTypeOptions = VENDOR_TYPES_IN_FILTER.map((value) => ({
  value,
  label: VendorTypeDescription[value],
}));


export const inputsFilter: InputFactoryProp[] = [
    { 
        element: 'input',
        type: 'text',
        placeHolder: 'Nombre',
        icon: <SearchOutlined style={{ color: COLORS.neutrals[50] }} />,
        name: 'name',
        className: 'step-2'
    },
    { 
        element: 'select',
        placeHolder: 'Tipo Proveedor',
        items: vendorTypeOptions,
        name: 'vendorType',
        className: 'step-3'
    },
];